import { __assign, __rest } from "tslib";
import React from "react";
import VeltCommentDialogLegacySuggestionActionAccept from "./VeltCommentDialogLegacySuggestionActionAccept/VeltCommentDialogLegacySuggestionActionAccept";
import VeltCommentDialogLegacySuggestionActionReject from "./VeltCommentDialogLegacySuggestionActionReject/VeltCommentDialogLegacySuggestionActionReject";
import { transformWireframeProps } from '../../../utils/propUtils';
;
/**
 * @deprecated Renamed from VeltCommentDialogSuggestionAction* on 2026-07-20 to mirror the SDK's legacy rename
 * (velt-comment-dialog-legacy-suggestion-action*). Unreachable inside dialogs; kept for standalone usage.
 */
var VeltCommentDialogLegacySuggestionAction = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-legacy-suggestion-action-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogLegacySuggestionAction.Accept = VeltCommentDialogLegacySuggestionActionAccept;
VeltCommentDialogLegacySuggestionAction.Reject = VeltCommentDialogLegacySuggestionActionReject;
export default VeltCommentDialogLegacySuggestionAction;
